import { useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

/**
 * A page served as a CMS preview connects to the Studio's Preview tool, which
 * frames it. When a draft changes, or the tool's Refresh button is pressed,
 * the route loaders run again and the page redraws from the new draft. The
 * tool refreshes nothing by itself after an edit, so the handler is required.
 * Nothing is drawn over the page (no overlays, no stega in the copy), and the
 * module is fetched for a preview alone.
 */
export function useCmsPreview(preview: boolean): void {
  const router = useRouter();
  useEffect(() => {
    if (!preview) {
      return;
    }
    let cancelled = false;
    let disable: (() => void) | undefined;
    void import("@sanity/visual-editing").then(({ enableVisualEditing }) => {
      if (!cancelled) {
        disable = enableVisualEditing({ refresh: () => router.invalidate() });
      }
    });
    return () => {
      cancelled = true;
      disable?.();
    };
  }, [preview, router]);
}
